// Local-development gate for dev-only UI (preview triggers, skip buttons...).
//
// Deployed builds pull their env file from GCS at build time (see cloudbuild/),
// so REACT_APP_ENV alone can't be trusted to separate a laptop from the sandbox
// deploy — the hostname pin guarantees dev-only UI never appears on
// sandbox/production even if the env values drift.
export const isLocalDev = (): boolean =>
    process.env.REACT_APP_ENV === "dev" && window.location.hostname === "localhost"
